import { render, staticRenderFns } from "./XkYcPayDetail.vue?vue&type=template&id=89cf5e56&scoped=true"
import script from "./XkYcPayDetail.vue?vue&type=script&lang=js"
export * from "./XkYcPayDetail.vue?vue&type=script&lang=js"
import style0 from "./XkYcPayDetail.vue?vue&type=style&index=0&id=89cf5e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cf5e56",
  null
  
)

export default component.exports